/* eslint-disable no-param-reassign */

export default {
	setViewportSize(state, payload) {
		state.viewportSize = payload;
	},
};
